import { NidusEntry, NidusEntryData, NidusEntryId, NidusSearchResponse } from "../INidusClient";

export interface IContextualNidusClient {
    search(searchValue: string | null | undefined): Promise<NidusSearchResponse>;
    insert(obj: NidusEntryData): Promise<NidusEntry>;
    delete(objectId: NidusEntryId): Promise<void>;
    update(objectId: NidusEntryId, obj: NidusEntryData): Promise<void>;
    batchInsert(objects: NidusEntry[]): Promise<void>;
}
